var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "a-tabs",
        {
          attrs: {
            activeKey: _vm.tabsKey,
            "default-active-key": "1",
            size: "large",
            "tab-bar-style": { marginBottom: "12px", paddingLeft: "16px" }
          },
          on: { change: _vm.changeTabs }
        },
        [
          !_vm.value.id || (!!_vm.value.id && _vm.tabsKey == 1)
            ? _c(
                "a-tab-pane",
                {
                  key: "1",
                  attrs: {
                    loading: "true",
                    tab: _vm.language["system.certificate.mrcCode"]
                  }
                },
                [
                  _c("sys-certificate-mrc-code-form", {
                    ref: "mrcCodeForm",
                    attrs: {
                      disabled: _vm.disabled,
                      islock: _vm.islock,
                      systemlist: _vm.systemlist
                    },
                    on: { ok: _vm.submitCallback }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.value.id || (!!_vm.value.id && _vm.tabsKey == 2)
            ? _c(
                "a-tab-pane",
                {
                  key: "2",
                  attrs: {
                    loading: "true",
                    tab: _vm.language["system.certificate.cbCode"]
                  }
                },
                [
                  _c("sys-certificate-cb-code-form", {
                    ref: "cbCodeForm",
                    attrs: {
                      disabled: _vm.disabled,
                      islock: _vm.islock,
                      systemlist: _vm.systemlist
                    },
                    on: { ok: _vm.submitCallback }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }